'use client'

import { ABHA_HERO_SUCCESS_DOWNLOAD_ABHA_CTA, ABHA_HERO_SUCCESS_SHOW_BADGE } from '@components/NewProduct/constants'
import { AbhaHeroCard } from '@components/NewProduct/AbhaHeroWidget/steps/AbhaHeroCard'
import { AbhaHeroSuccessBadge } from '@components/NewProduct/AbhaHeroWidget/steps/AbhaHeroSuccessBadge'
import { AbhaHeroSuccessDownloadButton } from '@components/NewProduct/AbhaHeroWidget/steps/AbhaHeroSuccessDownloadButton'
import type { AbhaSuccessCardVariant } from '@components/NewProduct/AbhaHeroWidget/steps/abhaSuccessTypes'
import type { AbhaCardPreviewData } from '@helpers/abhaWidgetHelper'

export type AbhaHeroSuccessLeftPanelProps = {
  cardVariant: AbhaSuccessCardVariant
  cardData: AbhaCardPreviewData
  badgeText?: string
  downloadAbhaCtaText?: string
  onDownloadAbhaCard?: () => void
}

export const AbhaHeroSuccessLeftPanel = ({
  cardVariant,
  cardData,
  badgeText,
  downloadAbhaCtaText,
  onDownloadAbhaCard,
}: AbhaHeroSuccessLeftPanelProps) => {
  const panelCardData: AbhaCardPreviewData = {
    ...cardData,
    relationshipLabel: undefined,
  }

  if (cardVariant === 'showAbhaNumber') {
    return (
      <div className="abha-hero-success__desktop-visual abha-hero-success__desktop-visual--show">
        <div className="abha-hero-success__show-stack">
          <AbhaHeroSuccessBadge
            label={badgeText ?? ABHA_HERO_SUCCESS_SHOW_BADGE}
            variant="onShowSurface"
          />

          <div className="abha-hero-success__show-panel">
            <AbhaHeroCard
              data={panelCardData}
              layout="resolve"
              variant="showAbhaNumber"
              animateReveal={false}
              className="abha-hero-success__card abha-hero-success__card--desktop-show"
            />

            <AbhaHeroSuccessDownloadButton
              label={downloadAbhaCtaText ?? ABHA_HERO_SUCCESS_DOWNLOAD_ABHA_CTA}
              onClick={() => onDownloadAbhaCard?.()}
              fullWidth
            />
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="abha-hero-success__desktop-visual abha-hero-success__desktop-visual--hide">
      <div className="abha-hero-success__hide-card-stage">
        <AbhaHeroCard
          data={panelCardData}
          variant="hideAbhaNumber"
          className="abha-hero-success__card abha-hero-success__card--desktop-hide"
        />
      </div>
    </div>
  )
}
